import styled from '@emotion/styled';
import { Grid, styled as muiStyled, Typography } from '@mui/material';
const crouselBg = require('assets/buku_1.jpg');

export const Body = styled('div')`
  position: relative;
  display: flex !important;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${window.innerWidth === 1200 ? '150vh' : '100vh'}
  background: #454350;
  background-image: url(${crouselBg});
  background-size: cover;
  padding: 40px 0px;
  flex-wrap: wrap;
`;

export const BodyOverlay = styled('div')`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(69, 67, 80, 0.8);
  z-index: 0;
`;

export const HomeSection = muiStyled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  zIndex: 10,
}));

export const HomeSubSection = muiStyled(Grid)(({ theme }) => ({
  display: 'flex',
  borderRadius: '20px',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  // marginBottom: '3rem',
  [theme.breakpoints.down(1200)]: {
    flex: '1 0 100%',
  },
  // @media only screen and (max-width: 1200px) {
  // }
}));

export const HomeText = muiStyled('div')(({ theme }) => ({
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    paddingRight: '0rem !important',
    paddingLeft: '0rem !important',
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}));

export const TitleText = muiStyled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '2rem',
  fontWeight: 'bold',
  marginBottom: '20px',
}));

export const ParaText = muiStyled(TitleText)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: '300',
  color: '#e5e5e5',
  [theme.breakpoints.down('md')]: {
    fontSize: '.9rem',
  },
  display: 'flex',
  gap: '25px',
  alignItems: 'center',
}));

export const HelpText = muiStyled(ParaText)(({ theme }) => ({
  fontSize: '17px',
  fontWeight: '300',
  color: '#c1c1c1',
  margin: '10px 0px',
  display: 'flex',
  justifyContent: 'center',
}));

export const SectionVideoCont = muiStyled('div')(({ theme }) => ({
  position: 'relative',
  width: '90%',
  height: '60vh',
  borderRadius: '20px',
  boxShadow: theme.shadows[8],
  overflow: 'hidden',
  marginLeft: '40px',
}));

export const SectionVideo = muiStyled('video')(({ theme }) => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}));

export const FeaturesCont = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  margin: 20px 0px;
`;

export const FeaturesItem = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 300px;
  background-color: rgba(255, 255, 255, 0.1);
  height: 80px;
  border-radius: 20px;
  color: #fff;
  padding: 20px;
  & h5 {
    font-size: 13px;
    margin: 0px;
  }

  & p {
    font-size: 15px;
    margin: 0px;
    color: #c1c1c1;
  }
  @media only screen and (max-width: 620px) {
    flex: 0 1 100%;
  }
`;

export const TextCont = muiStyled('div')(() => ({
  position: 'absolute',
  left: '50%',
  bottom: '0px',
  transform: 'translateX(-50%)',
  width: '60%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  flexDirection: 'column',
  textAlign: 'center',
}));

export const ButtonCont = styled('div')`
  display: flex;
  gap: 20px;
  padding: 0px 30px;
  @media only screen and (max-width: 620px) {
    padding: 0px 0px;
  }
  flex: 1;
`;

export const GenesisNftItem = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  /* flex: 0 1 calc(50% - 40px); */
  width: calc(100% - 140px);
  background-color: rgba(255, 255, 255, 0.1);
  height: 120px;
  border-radius: 20px;
  color: #fff;
  padding: 20px;
  & h5 {
    font-size: 13px;
    margin: 0px;
  }
  & p {
    font-size: 15px;
    margin: 0px;
    color: #c1c1c1;
  }
  @media only screen and (max-width: 620px) {
    flex: 0 1 100%;
  }
`;
